import { GridOptions } from "@ag-grid-community/all-modules";
import { sumArray } from "common/decimal";

const defaultGridOptions: GridOptions = {
    suppressContextMenu: true,
    enableCellTextSelection: true,
    suppressMovableColumns: true,
    rowHeight: 24,
    headerHeight: 24,
    aggFuncs: {
        "npSum": params => sumArray(params.values)
    }
};

export default defaultGridOptions